import Layer from "./Layer";
import Vector2 from "./Vector2";
import Rect from "./Rect";
import ConnectionLayer from "./ConnectionLayer";
import NodeLayer from "./NodeLayer";

export default class LayerGroup {
  private _layers = new Array<Layer>();

  public get layers(): Array<Layer> {
    return this._layers;
  }

  public addLayer(layer: Layer) {
    this._layers.push(layer);
  }

  public removeLayer(layer: Layer) {
    var index = this._layers.indexOf(layer);
    if (index > -1) {
      this._layers.splice(index, 1);
    }
  }

  public removeNodeLayer(nodelayer: NodeLayer) {
    var index = this._layers.indexOf(nodelayer);
    if (index > -1) {
      this._layers.splice(index, 1);
    }
  }

  public findNodeLayerById(id: string): NodeLayer {
    var ret: NodeLayer = null;

    this._layers.forEach((layer) => {
      if (id == layer.id && layer instanceof NodeLayer) {
        ret = layer;
      }
    });

    return ret;
  }

  public checkPointIntersection(point: Vector2): Layer {
    for (var i = 0; i < this._layers.length; i++) {
      var layer = this._layers[this._layers.length - i - 1];
      if (layer.checkPointIntersection(point)) {
        return layer;
      }
    }

    return null;
  }

  public bringToFront(layer: Layer) {
    this._layers = this._layers.filter((it) => it != layer);
    this._layers.push(layer);
  }
}
